import Card from "./Card"
import "./Main.scss";


const Main = () => {
  return (
    <main>
      <Card/>
    </main>
  )
}

export default Main
